import {injectable} from 'inversify';
import axios from 'restyped-axios';

import {lazyInject, TYPES} from '../utils/inversify-config';
import {IComprobante, ILiquidacion, IProductoADevolver, IResumenDiario} from '../utils/models';
import {setIsProcessLoading, setResumenDiarioXRuta} from '../reduxstore/actions/action-creators';
import {error} from '../utils/notification-actions';
import {ACCESS_TOKEN} from '../utils/constants';
import FirebaseClient from './firebase';

const apiURL = `${process.env.REACT_APP_API_URL}/api`;

const client = axios.create<{}>({
    baseURL: apiURL
});


@injectable()
export class MeepoServiceClient {

    @lazyInject(TYPES.REDUX_STORE)
    public store;

    @lazyInject(TYPES.FIREBASE)
    public firebase: FirebaseClient;

    public request = (options): Promise<any> => {
        const user = this.firebase.getApp().auth().currentUser;
        if (user != null) {
            user.getIdToken().then((idToken) => {
                localStorage.setItem(ACCESS_TOKEN, idToken);
            });
        }

        if (localStorage.getItem(ACCESS_TOKEN)) {
            // tslint:disable-next-line
            client.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem(ACCESS_TOKEN);
        }
        return new Promise<any>((resolve, reject) => {
            client.request(options).then((response) => {
                return resolve(response.data);
            }).catch((error) => {
                    reject(error)
                }
            );
        });
    };

    private async resumenesDiarios(fecha?: string): Promise<IResumenDiario[]> {
        return this.request({
            url: '/resumenes',
            params: {
                fecha
            },
            method: 'GET'
        });
    }

    public async obtenerComprobantesPorRuta(rutaId: string, fecha?: string): Promise<IComprobante[]> {
        return this.request({
            url: `/rutas/${rutaId}/comprobantes`,
            method: 'GET',
            params: {
                todos: true,
                fecha
            }
        });
    }

    public async obtenerCambiosPorRuta(rutaId: string, fecha?: string): Promise<IComprobante[]> {
        return this.request({
            url: `/rutas/${rutaId}/cambios`,
            method: 'GET',
            params: {
                todos: true,
                fecha
            }
        });
    }

    public async obtenerResumenPorRuta(rutaId: string, fecha?: string): Promise<IResumenDiario> {
        return this.request({
            url: `/rutas/${rutaId}/resumen`,
            params: {
                fecha
            },
            method: 'GET'
        });
    }

    public async cargarResumenesDiariosXRuta(fecha?: string) {
        try {
            this.store.dispatch(setIsProcessLoading(true));
            const response = await this.resumenesDiarios(fecha);
            this.store.dispatch(setResumenDiarioXRuta(response));
        } catch (ex) {
            this.store.dispatch(error('Error', 'Error al obtener resumen por ruta'));
        } finally {
            this.store.dispatch(setIsProcessLoading(false));
        }

    }

    public async obtenerLiquidacion(fecha: string): Promise<ILiquidacion[]> {
        return this.request({
            url: `/liquidacion`,
            params: {
                fecha
            }
        });
    }

    public async obtenerProductosADevolver(rutaId: string): Promise<IProductoADevolver[]> {
        return this.request({
            url: `/rutas/${rutaId}/productos/devolucion`
        });
    }

    public async obtenerCambiosADevolver(rutaId: string): Promise<IProductoADevolver[]> {
        return this.request({
            url: `/rutas/${rutaId}/cambios/devolucion`
        });
    }

}

export default MeepoServiceClient;



// WEBPACK FOOTER //
// ./src/middleware/meepo-client.ts